import Layout from "../components/layout";
import * as React from "react";

const KontaktPage = () => {
  return (
    <Layout title={'Weitere Infos'}>
      <section className="p-8">
        <h1>
          Weitere Infos
        </h1>
        <h2 className="font-pretty">Corona-Regelung</h2>
        <p>Da wir in der aktuellen Zeit noch nicht genau wissen, wie die Regeln im Mai aussehen werden, findet unsere Hochzeit nach jetzigem Stand als 2G+ Veranstaltung statt.</p>
        <h2 className="font-pretty">Dresscode</h2>
        <p>Festlich chic</p>
        <h2 className="font-pretty">Anfahrt</h2>
        <p>Direkt bei der Location gibt es genügend Parkplätze. Nachts ist es möglich, sich ein Taxi zu eurem Hotel zu nehmen.</p>
        <h3 className={"font-bold"}>St. Georg Kirche</h3>
        <div className={"mapWrapper"}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2354.128511948231!2d10.647321351499043!3d53.840578145179194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b20fbb360f9525%3A0x2ef87706a892f76f!2sSt.-Georg-Kirche%20L%C3%BCbeck%20Genin%20-%20Ev.-Luth.%20Kirchengemeinde%20St.%20Georg%20in%20L%C3%BCbeck%20Genin!5e0!3m2!1sen!2sde!4v1639347824873!5m2!1sen!2sde"
            className={"mt-3"}
            style={{ border: 0 }} allowFullScreen="" loading="lazy"/>
        </div>
        <h3 className={"font-bold mt-8"}>Gut Mönkhof</h3>
        <div className={"mapWrapper"}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2354.8534371567403!2d10.69620595149868!3d53.82768314615096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b2091d24c820ef%3A0x9ca53424e4519748!2sGut%20M%C3%B6nkhof!5e0!3m2!1sen!2sde!4v1639347938455!5m2!1sen!2sde"
            className={"mt-3"}
            style={{ border:0 }} allowFullScreen="" loading="lazy"/>
        </div>
        <h2 className="font-pretty mt-16">Fragen?</h2>
        <p>Wenn ihr noch Fragen habt, kontaktiert gerne <span className={"font-bold"}>Anna</span> oder <span className={"font-bold"}>Willem</span>.</p>
      </section>
    </Layout>
  )
}

export default KontaktPage
